import { postProductCheckout } from './postProductCheckout';

export const orderService = {
  postProductCheckout,
};
